export default "__VITE_ASSET__UoE1iw5R__"